'use strict';

var FirebaseIndirectArray = require('./FirebaseIndirectArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeUtil = require('./KayleeUtil');
var KayleeVisualTheme = require('./KayleeVisualTheme');

var KayleeVisualThemes = {
    fromJson: fromJson,
    getVisualThemes: getVisualThemes,
};

function fromJson(data) {
    var reqProps = [];
    return FirebaseIndirectArray.fromJson(data, 'VisualThemes', reqProps, reqProps,
        function(data) { return getVisualThemes(); }
    );
}

function getVisualThemes() {
    var key = 'Visual Themes';
    var visualThemes = KayleeCache.get(key);

    if (visualThemes === null) {
        visualThemes = new VisualThemes();
        KayleeCache.put(key, visualThemes);
    }

    return visualThemes;
}

function VisualThemes() {
    this.$nodeType = 'visualThemes';
    var ref = KayleeBase.app.database().ref('visualThemes');
    FirebaseIndirectArray.call(this, ref, KayleeVisualTheme.getVisualTheme);
    KayleeUtil.bindPrototypeMethods(KayleeVisualThemes.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

VisualThemes.prototype = Object.create(FirebaseIndirectArray.prototype);
VisualThemes.prototype.constructor = VisualThemes;

VisualThemes.prototype.$toJson = function() {
    return FirebaseIndirectArray.prototype.$toJson.call(this, [], {});
};

VisualThemes.prototype.toString = function() {
    return '[VisualThemes]';
};

module.exports = KayleeVisualThemes;